var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 113,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.711 45.203h-2.578v-3.9c0-.718-.577-1.3-1.29-1.3h-8.12c-.712 0-1.29.582-1.29 1.3v3.9h-5.156v-3.9c0-.718-.577-1.3-1.289-1.3h-8.12c-.713 0-1.29.582-1.29 1.3v3.9h-5.156v-3.9c0-.718-.577-1.3-1.29-1.3h-8.12c-.712 0-1.29.582-1.29 1.3v3.9h-5.156v-3.9c0-.718-.577-1.3-1.289-1.3h-8.12c-.713 0-1.29.582-1.29 1.3v3.9H39.29c-.712 0-1.289.582-1.289 1.3V64.7c0 .718.577 1.3 1.29 1.3h63.421c.712 0 1.289-.582 1.289-1.3V46.502c0-.717-.577-1.3-1.289-1.3zm-62.133 2.6h2.578c.712 0 1.29-.582 1.29-1.3v-3.9h5.542v3.9c0 .718.577 1.3 1.29 1.3h7.734c.712 0 1.289-.582 1.289-1.3v-3.9h5.543v3.9c0 .718.577 1.3 1.289 1.3h2.578V63.4H40.578V47.802zM101.422 63.4H72.289V47.802h2.578c.712 0 1.29-.581 1.29-1.3v-3.899h5.542v3.9c0 .718.577 1.3 1.29 1.3h7.734c.712 0 1.289-.582 1.289-1.3v-3.9h5.543v3.9c0 .718.577 1.3 1.289 1.3h2.578V63.4z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.592 34.997h22.63v-2.6H56.876V16.799h2.568c.71 0 1.284-.582 1.284-1.3v-3.9h5.136v3.9c0 .718.575 1.3 1.284 1.3h7.704c.71 0 1.284-.582 1.284-1.3v-3.9h5.136v3.9c0 .718.575 1.3 1.284 1.3h2.568v15.598h-8.346v2.6h9.63c.71 0 1.284-.582 1.284-1.3V15.499c0-.718-.575-1.3-1.284-1.3H83.84v-3.9c0-.717-.575-1.299-1.284-1.299h-7.704c-.71 0-1.284.582-1.284 1.3v3.9h-5.136v-3.9c0-.718-.575-1.3-1.284-1.3h-7.704c-.71 0-1.284.582-1.284 1.3v3.9h-2.568c-.71 0-1.284.581-1.284 1.3v18.197c0 .718.575 1.3 1.284 1.3z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.95 0H7.05a7.065 7.065 0 00-4.979 2.075A7.09 7.09 0 000 7.062v75.334a7.09 7.09 0 002.071 4.988 7.065 7.065 0 004.979 2.074h46.577l-1.575 9.417H49.35a2.378 2.378 0 00-1.88.942l-7.05 9.416a2.358 2.358 0 00.645 3.415c.37.23.799.352 1.235.352h56.4a2.346 2.346 0 002.102-1.301 2.363 2.363 0 00-.222-2.466l-7.05-9.416a2.383 2.383 0 00-1.88-.942h-2.703l-1.574-9.417h46.577a7.065 7.065 0 004.979-2.074A7.092 7.092 0 00141 82.396V7.062a7.091 7.091 0 00-2.071-4.987A7.065 7.065 0 00133.95 0zM91.475 102.583L95 109.292H46l3.525-6.709h41.95zm-34.652-3.708l1.575-9.417h24.205l1.574 9.417H56.823zm79.477-16.48a2.35 2.35 0 01-2.35 2.354H7.05a2.348 2.348 0 01-2.35-2.353v-9.063h131.6v9.063zm0-11.77H4.7V7.062a2.356 2.356 0 012.35-2.354h126.9a2.35 2.35 0 012.35 2.354v63.563z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 70.5,
    y1: 0,
    x2: 70.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADF795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03BC9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 70.5,
    y1: 0,
    x2: 70.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADF795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03BC9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 70.5,
    y1: 0,
    x2: 70.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADF795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03BC9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.cc9d93054cd837bff1bc4f55b0f36f43.svg";
export { ForwardRef as ReactComponent };